export const ANSWER_KEY = 'answerKeys'
export const ANSWER_TEXT = 'answerText'
export const ANSWER = 'answer'
export const ANSWER_NUMERIC = 'answerNumeric'

export const ADDRESS_DETAILS_KEY = 'addressDetails'
export const BOARD_DETAILS_KEY = 'boardDetails'

export const ADDRESS_GROUP_NAME = 'Address'
export const BOARD_COMPOSITION_GROUP_NAME = 'Board Composition'
export const HEAD_OFFICE = 'HeadOffice'
export const BRANCH_OFFICE_S = 'Branch Office(s)'
export const HEAD = 'Head'
export const BRANCH = 'Branch'
export const ORGANIZATION_PROFILE = 'Organization Profile'

// Regulation List
export const RACI_MATRIX_KEYS = ['responsible', 'accountable', 'consulted', 'informed']
export const RACI_MATRIX_REQUIRED_KEYS_COMPLIANCE = ['responsible', 'accountable']
export const RACI_MATRIX_REQUIRED_KEYS_REGULATORY = ['accountable']
export const DEPARTMENT_KEY = 'department'
export const ROLE_KEY = 'role'
export const NAME_KEY = 'name'

//  Stepper Keys
export const PROFILE_STEPPER = 0
export const MANAGEMENT_TEAM_STEPPER = 1
export const ORGANIZATION_CHART_STEPPER = 2
export const BODIES_LIST_STEPPER = 3
export const CONFIGURATION_STEPPER = 4
// Drawer event type Keys
export const KEYDOWN = 'keydown'
export const TAB = 'Tab'
export const SHIFT = 'Shift'

// Organization Chart Types
export const FROM_DATE = 'fromDate'
export const TO_DATE = 'toDate'
export const PHONE_NUMBER = 'phoneNumber'
export const ROLE = 'role'
export const AT_PRESENT = 'atPresent'
export const IS_VACANT = 'isVacant'
export const FIRST_NAME = 'firstName'
export const LAST_NAME = 'lastName'
export const EMAILID = 'emailId'
export const DEPARTMENT_NAME = 'department'
export const PARENT_DEPARTMENT_NAME = 'parentDepartment'
export const DESIGNATION_NAME = 'designation'
export const PARENT_DESIGNATION_NAME = 'parentDesignation'
export const PARENT_NAME = 'parentName'

// board member
export const ADDRESS = 'address'
export const COUNTRY = 'country'
export const STATE = 'state'
export const CITY = 'city'
export const PIN_CODE = 'pincode'

// length
export const LENGTH_THREE = 3

// input
export const PHONE_NUMBER_LABEL = 'Phone Number'
export const ORGANIZATION_NAME_LABEL = 'Organization Name'
export const INDUSTRY_LABEL = 'Industry'
export const EMAIL_ID_LABEL = 'Email ID'

export const FIRST_NAME_LABEL = 'First Name'
export const MIDDLE_NAME_LABEL = 'Middle Name'
export const LAST_NAME_LABEL = 'Last Name'
export const APARTMENT_LABEL = 'Apartment/House/Street'
export const PINCODE_LABEL = 'Pincode'

export const CURRENCY_CODE = [{ id: 1, currencyName: 'United States dollar', name: 'USD', status: 1 }, { id: 2, currencyName: 'Indian rupee', name: 'INR', status: 1 }, { id: 3, currencyName: 'Euro', name: 'EURO', status: 1 }]
export const DATE_FORMATE = [{ id: 1, name: 'DD/MM/YYYY', status: 1 }, { id: 2, name: 'MM/DD/YYYY', status: 1 }]
export const HEAT_MAP = [{ id: 1, name: '3x3', status: 1 }, { id: 2, name: '5x5', status: 1 }]

export const LANGUAGE = [{ id: 1, name: 'English' }, { id: 2, name: 'Tamil' }, { id: 3, name: 'Hindi' }]

export const INITIAL_PROFILE_DATA = {
    id: null,
    name: '',
    organizationTypeId: null,
    industry: '',
    dateFormat: '',
    currencyCode: '',
    currencyName: '',
    heatmapId: null,
    heatmap: {
        id: null,
        name: ''
    },
    status: 1,
    financialYearId: null,
    financialYear: {
        id: null,
        fromDate: '2024-10-29T21:21:38.271268Z',
        toDate: '2024-10-30T21:21:38.271268Z',
        status: 1
    },
    orgAddress: [
        {
            tabName: 'Head/Corporate Office',
            orgId: '',
            street: '',
            countryId: '',
            stateId: '',
            cityId: '',
            pincode: '',
            addressTypeId: 1,
            isRegisteredAddress: true,
            status: 1,
            addressId: 0
        },
        {
            tabName: 'Branch Office(s)',
            orgId: '',
            street: '',
            countryId: '',
            stateId: '',
            cityId: '',
            pincode: '',
            addressTypeId: 2,
            isRegisteredAddress: false,
            status: 1,
            addressId: 0
        }
    ]
}

export const ORG_LOGO_KEY = 'orgLogo'
const orgId = localStorage.getItem('orgId')
export const defaultRaciMatrices =
    [
        {
            department: 'nodata',
            departmentId: null,
            orgRegulationId: 2,
            organizationId: +orgId,
            orgId: +orgId,
            profilePic: null,
            raciId: 1,
            role: null,
            roleId: null,
            status: null,
            user: null,
            userId: null,
            rootId: 0
        },
        {
            department: 'nodata',
            departmentId: null,
            orgRegulationId: 2,
            organizationId: +orgId,
            orgId: +orgId,
            profilePic: null,
            raciId: 2,
            role: null,
            roleId: null,
            status: null,
            user: null,
            userId: null,
            rootId: 0
        },
        {
            department: 'nodata',
            departmentId: null,
            orgRegulationId: 2,
            organizationId: +orgId,
            orgId: +orgId,
            profilePic: null,
            raciId: 3,
            role: null,
            roleId: null,
            status: null,
            user: null,
            userId: null,
            rootId: 0
        },
        {
            department: 'Management Structure',
            departmentId: -1,
            orgRegulationId: 2,
            organizationId: +orgId,
            orgId: +orgId,
            profilePic: null,
            raciId: 4,
            role: 'Board of Directors',
            roleId: -6,
            status: null,
            user: null,
            userId: null,
            rootId: 0
        }
    ]

export const generalCompData = [
    { id: 1, byWhen: new Date(), regulation: 'MCA', complianceTitle: 'Change in Authorized Share Capital', description: 'Report increase in authorized capital to MCA.', form: 'Form SH-7', toggle: 'No' },
    { id: 2, byWhen: new Date(), regulation: 'MCA', complianceTitle: 'Return of Allotment of Shares', description: 'File details of shares allotted after issue.', form: 'Form PAS-3', toggle: 'No' },
    { id: 3, byWhen: new Date(), regulation: 'MCA', complianceTitle: 'Filing of Resolutions', description: 'File resolutions for capital change, loans, borrowings, etc.', form: 'Form MGT-14', toggle: 'No' },
    { id: 4, byWhen: new Date(), regulation: 'MCA', complianceTitle: 'Appointment/Resignation of Director', description: 'Report appointment or resignation of director/partner.', form: 'Form DIR-12', toggle: 'No' },
    { id: 5, byWhen: new Date(), regulation: 'MCA', complianceTitle: 'Declaration for Commencement of Business', description: 'Declare that the company has commenced business operations.', form: 'Form INC-20A', toggle: 'No' },
    { id: 6, byWhen: new Date(), regulation: 'MCA', complianceTitle: 'Change in Registered Office Address', description: 'Notify MCA about registered office address change.', form: 'Form INC-22', toggle: 'No' },
    { id: 7, byWhen: new Date(), regulation: 'MCA', complianceTitle: 'Creation / Modification of Charge', description: 'Register details of charge created on company assets.', form: 'Form CHG-1', toggle: 'No' },
    { id: 8, byWhen: new Date(), regulation: 'MCA', complianceTitle: 'Satisfaction of Charge', description: 'Report repayment of secured loan or discharge of charge.', form: 'Form CHG-9', toggle: 'No' },
    { id: 9, byWhen: new Date(), regulation: 'MCA', complianceTitle: 'Appointment of Auditor', description: 'Inform MCA of auditor appointment made at AGM.', form: 'Form ADT-1', toggle: 'No' },
    { id: 10, byWhen: new Date(), regulation: 'MCA', complianceTitle: 'Return of Deposits / Loans', description: 'Submit details of deposits and loans not considered deposits.', form: 'Form DPT-3', toggle: 'No' },
    { id: 11, byWhen: new Date(), regulation: 'MCA', complianceTitle: 'Application for Strike Off', description: 'Voluntary closure of company through strike off.', form: 'Form MGT-10 / INC-20', toggle: 'No' },
    { id: 12, byWhen: new Date(), regulation: 'IRDAI', complianceTitle: 'Application for License', description: 'Apply to IRDAI for registration as an insurance broker.', form: 'Form A (IRDAI (Insurance Brokers) Regulations, 2018)', toggle: 'No' },
    { id: 13, byWhen: new Date(), regulation: 'IRDAI', complianceTitle: 'Capital & Net Worth', description: 'Maintain prescribed minimum capital & net worth.', form: 'Supporting Documents (CA Certificate)', toggle: 'No' },
    { id: 14, byWhen: new Date(), regulation: 'IRDAI', complianceTitle: 'Professional Indemnity Insurance', description: 'Obtain Professional Indemnity Policy covering E&O risks.', form: 'Insurance Policy Copy', toggle: 'No' },
    { id: 15, byWhen: new Date(), regulation: 'IRDAI', complianceTitle: 'Infrastructure & Personnel', description: 'Ensure qualified personnel and office infrastructure.', form: 'Infrastructure & HR Proofs', toggle: 'No' },
    { id: 16, byWhen: new Date(), regulation: 'IRDAI', complianceTitle: 'Fee Payment', description: 'Pay IRDAI Application & Registration Fees.', form: 'Bank Receipt / UTR Proof', toggle: 'No' },
    { id: 17, byWhen: new Date(), regulation: 'IRDAI', complianceTitle: 'Bank Guarantee', description: 'Submit bank guarantee in favor of IRDAI.', form: 'Bank Guarantee Copy', toggle: 'No' },
    { id: 18, byWhen: new Date(), regulation: 'IRDAI', complianceTitle: 'Fit & Proper Criteria', description: 'Declaration by promoters/directors/Principal Officer.', form: 'Form B & Form C', toggle: 'No' }
].map(item => ({ ...item, raciMatrices: defaultRaciMatrices.map(raci => ({ ...raci, rootId: item.id })) }))
export const omanCompData = [
    // OLL
    { sNo: 1, regulation: 'OLL', complianceTitle: 'Employer Registration (PASI)', frequency: 'One-time', date: 'At business setup', form: 'PASI Registration', toggle: 'No' },
    { sNo: 2, regulation: 'OLL', complianceTitle: 'Leave Entitlements', frequency: 'Ongoing', date: 'As per policy', form: 'Leave Register', toggle: 'No' },
    { sNo: 3, regulation: 'OLL', complianceTitle: 'Health & Safety Compliance', frequency: 'Ongoing', date: 'Continuous', form: 'H&S Checklist', toggle: 'No' },
    { sNo: 4, regulation: 'OLL', complianceTitle: 'Employee Records Retention', frequency: 'Ongoing', date: 'Continuous', form: 'Employee Files', toggle: 'No' },
    { sNo: 5, regulation: 'OLL', complianceTitle: 'Minimum Wage for Omanis', frequency: 'Ongoing', date: 'Monthly payroll', form: 'Payroll Records', toggle: 'No' },

    // VAT
    { sNo: 6, regulation: 'VAT', complianceTitle: 'VAT Registration', frequency: 'One-time', date: 'Upon threshold crossing', form: 'VAT Registration Form', toggle: 'No' },
    { sNo: 7, regulation: 'VAT', complianceTitle: 'VAT on Sales (Output Tax)', frequency: 'Ongoing', date: 'Each tax period', form: 'Sales VAT Records', toggle: 'No' },
    { sNo: 8, regulation: 'VAT', complianceTitle: 'Zero-rated & Exempt Treatment', frequency: 'Ongoing', date: 'Continuous', form: 'VAT Classification Sheet', toggle: 'No' },
    { sNo: 9, regulation: 'VAT', complianceTitle: 'Maintain VAT Records', frequency: 'Ongoing', date: '10 years', form: 'VAT Ledger', toggle: 'No' }
].map((item, index) => ({
    id: index + 1,
    ...item,
    description: item.complianceTitle,
    raciMatrices: defaultRaciMatrices.map(raci => ({
        ...raci,
        rootId: index + 1
    }))
}));
